import ownerDocument from './ownerDocument';
export default (function (componentOrElement) {
  var doc = ownerDocument(componentOrElement);
  return doc.defaultView;
});